import { Button, Flex } from '@chakra-ui/react';
import { ReactElement, memo, useCallback } from 'react';

import { ButtonMessageProps, MessageType } from '../Chat.types';

/**
 * Render the infographic design in the ChatPanel
 *
 * @param data.messages[0] button action name
 * @param data.messages[1] button text
 * @param data.messages[2] align item: start | center | end
 * @param data.messages[3] other data
 * @param data.children    Icon of the button
 */
export const ButtonMessage = memo(({ data, isDisabled = false, onUpdate }: ButtonMessageProps) => {
  const [actionName = '', text = '', alignItem = 'left'] = data.messages;
  const RotateIcon = data.children;
  const handleRegenerateClick = useCallback(() => {
    if (!actionName) return;
    onUpdate(MessageType.BUTTON, actionName, data);
  }, [data, actionName, onUpdate]);

  const ChatButtonMessageTestId = 'chat-button-message';

  return (
    <Flex justifyContent={alignItem} data-testid={ChatButtonMessageTestId}>
      <Button
        isDisabled={isDisabled}
        leftIcon={RotateIcon as ReactElement}
        size='xs'
        h='7'
        variant={'outline'}
        onClick={handleRegenerateClick}
        aria-label={actionName}
      >
        {text}
      </Button>
    </Flex>
  );
});

ButtonMessage.displayName = 'ButtonMessage';
